(function() {
  
class TrStreamHelper {
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);

  isProduction() {
    return window.location.host === 'stream.trakteer.id';
  }

  args(key) {
    return this.urlParams.get(key);
  }
  timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  setHTML(selector, html) { 
    const el = typeof selector === 'string' ? this.el(selector) : selector;
    el.innerHTML = html; 
  }
  incHTML(selector, html) { 
    const el = typeof selector === 'string' ? this.el(selector) : selector;
    el.innerHTML += html; 
  }
  setTextContent(selector, textContent) { 
    const el = typeof selector === 'string' ? this.el(selector) : selector;
    el.textContent = textContent; 
  }
  setStyle(selector, styles) { 
    for (const key in styles) {
      if (Object.hasOwnProperty.call(styles, key)) {
        this.el(selector).style[key] = styles[key];
      }
    }
  }
  setThemeVar(prop, value) { 
    document.documentElement.style.setProperty(prop, value); 
  }
  getThemeVar(prop, selector = null) {
    const el = selector ? document.querySelector(selector) : document.documentel;
    if (el) {
      const styles = getComputedStyle(el);
      return styles ? styles.getPropertyValue(prop) : null;
    } else {
      return null;
    }
  }

  hasHttp(url) {
    return /^(?:f|ht)tps?\:\/\//.test(url);
  }
  url(endpoint = '') { 
    return (this.args('sbx_url') || 'https://trakteer.id') + `/${endpoint}`;
  }
  apiUrl(endpoint = '') { 
    return (this.args('sbx_api_url') || 'https://api.trakteer.id') + `/v2/${endpoint}`;
  }
  widgetUrl(endpoint = '') { 
    return this.isProduction() ? `${window.location.origin}/${endpoint}` : `${window.location.origin}${this.rootPath()}/${endpoint}`; 
  }

  rootDomain(url) {
    try {
      const urlParts = new URL(url).hostname.split('.');
      return urlParts .slice(0) .slice(-(urlParts.length === 4 ? 3 : 2)) .join('.');
    } catch (error) {
      return url;
    }
  }
  rootPath() {
    return this.args('mod') == '1' ? '/stream-overlay/build' : '/'
  }
  dirPath() {
    let path = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))
    return path.replace(this.rootPath(), '').replace(/^\/+/g, '');
  }

  addHeadScript(src, attrs) {
    return new Promise(function (resolve, reject) {
      var script;
      script = document.createElement('script');
      script.src = src;
      for (const key in attrs) {
        if (Object.hasOwnProperty.call(attrs, key)) {
          script[key] = attrs[key]
        }
      }
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  addHeadStyle(src, attrs) {
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = src;
      link.onload = resolve;
      link.onerror = reject;
      for (const key in attrs) {
        if (Object.hasOwnProperty.call(attrs, key)) {
          link[key] = attrs[key]
        }
      }
      document.head.appendChild(link);
    });
  }

  el(selector, from = null) {
    if (!from) { from = document; }
    return from.querySelector(selector);
  }

  shadowEl(selector1, selector2) {
    try {
      return document.querySelector(selector1).shadowRoot.querySelector(selector2)
    } catch (error) {
      return null;
    }
  }

  prop(obj, path) {
    return path.split('.').reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, obj);
  }

  setProp(obj, path, val) {
    let i
    path = path.split('.')
    for (i = 0; i < path.length - 1; i++) {
      if (obj[path[i]] !== null && obj[path[i]] !== undefined) {
        obj = obj[path[i]]
      } else {
        obj[path[i]] = {}
        i--
      }
    }
    obj[path[i]] = val
  }

  cloneProp(obj) {
    return (typeof structuredClone === "function") ? structuredClone(obj) : JSON.parse(JSON.stringify(obj));
  }

  isTrue(val) {
    return val === true || val === 'true'
  }
  
  txtOverflow(txt, max, replace = '..') {
    if (txt.length > max) {
      txt = txt.substring(0, max - 2) + replace;
    }
    return txt;
  }

  async hashmap(filename) {
    if (!window['hashmap']) {
      window['hashmap'] = await fetch(h.widgetUrl('meta/hashmap.json') + '?v=2')
        .then((response) => response.json())
        .catch((error) => '{}');
    }
    return filename 
      ? (window['hashmap'][filename] || window['hashmap']['../' + filename] /* Add "../" for development */)
      : window['hashmap'];
  }

  replaceVar(html, key, value) {
    return value != null ? html.replaceAll(`{${key}}`, value) : html;
  }

  generateUniqueId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  getCurrentTimeStamp(ampm = null) {
    const now = new Date();
    let hours = String(now.getHours()).padStart(2, '0');
    let minutes = String(now.getMinutes()).padStart(2, '0');
    let seconds = String(now.getSeconds()).padStart(2, '0');
    let formattedTime = "";
    if (this.isTrue(ampm)) {
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Converts 0 hour to 12 for midnight
      formattedTime = `${hours}:${minutes} ${ampm}`;
    } else {
      formattedTime = `${hours}:${minutes}`; 
    }

    return formattedTime;
  }
  formateDate(dateString) {
    const date = new Date(dateString);
    // Format the date to "YYYY-MM-DD"
    const formattedDate = date.toISOString().split('T')[0];
    return formattedDate;
  }
  formatedTimeStamp(dateString,ampm = null) {
    // Replace space with 'T' to make it ISO 8601 format compatible
    const isoDateString = dateString.replace(' ', 'T');

    // Create a Date object from the formatted string
    const dateObject = new Date(isoDateString);

    // Extract hours and minutes in HH:mm format
    const options = { hour: '2-digit', minute: '2-digit', hour12: this.isTrue(ampm) };
    const time = new Intl.DateTimeFormat('en-US', options).format(dateObject);

    return time;
  }
  formatPrice(price) {
    const str = String(price)
    if (str.startsWith('Rp')) {
      return price;
    } else {
      return 'Rp ' + this.thousandSeperator(price);
    }
  }
  selectRandom(arr) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }
  thousandSeperator(str) {
    const parts = str.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // return parts.join(",");
    return parts[0];
  }
  escapeHtml(text) { 
    return text.replace(/</g, "&lt;").replace(/>/g, "&gt;"); 
  };
  updateVersionNotice(vAlign = 'top'){

    const notice = document.createElement('div');
    notice.textContent = '⚠️ Versi terbaru widget tersedia. Segera perbarui URL widget di dashboard Trakteer agar tetap berfungsi.';
    Object.assign(notice.style, Object.assign(vAlign == 'top' ? { top: '0' } : { bottom: '0' }, {
      position: 'fixed',
      left: '0',
      width: '100%',
      backgroundColor: '#ffcc00',
      color: '#000',
      fontWeight: 'bold',
      padding: '10px',
      fontSize: '14px',
      fontFamily: 'Arial, sans-serif',
      // textAlign: 'center',
      zIndex: 99999,
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
    }));

    // Tambahkan tombol untuk info detail (opsional)
    // const link = document.createElement('a');
    // link.href = 'https://trakteer.id/widget-update'; // ganti dengan link panduan update
    // link.target = '_blank';
    // link.textContent = ' Panduan Update';
    // link.style.color = '#000';
    // link.style.textDecoration = 'underline';
    // notice.appendChild(link);

    // Sisipkan ke halaman
    document.body.appendChild(notice);

    // const path = window.location.pathname;
    // const parts = path.split("/").filter(Boolean); // Remove empty strings

    // let fileName = parts[parts.length-1].replace(".html", "");
    // if(fileName == 'qr-code') {
    //   let newUrl = window.location.origin + '/' + parts[0] + '/' + parts[1] + '/qr-code/index.html' +  window.location.search;
    //   window.location.href = newUrl;
    // } else {
    //   let widgetParts = fileName.split("-").filter(Boolean);
  
    //   let widgetName = "";
    //   let themeName = "";
  
    //   widgetParts.forEach((item, index) => {
    //     if(index == widgetParts.length-1) {
    //       themeName = item;
    //     } else {
    //       widgetName = widgetName + item;
    //       if(index < widgetParts.length - 2) {
    //         widgetName = widgetName + '-';
    //       }
    //     }
    //   })
  
    //   let paramsUrl = window.location.search;
    //   if(!paramsUrl.includes(widgetId+'_theme=') && widgetId != null ) {
    //     paramsUrl = paramsUrl + '&' + widgetId + '_theme=' + themeName;
    //   }
    //   if(!paramsUrl.includes('mod=1')) {
    //     paramsUrl = paramsUrl + '&mod=1';
    //   }
    //   let newUrl = window.location.origin + '/' + parts[0] + '/' + parts[1] + '/' + widgetName + '/index.html' +  paramsUrl;
    //   window.location.href = newUrl;
    // }
    
    
  }
  removePrefix(str, prefix) {
    return str.startsWith(prefix) ? str.slice(prefix.length) : str;
  }
  
  waitUntil(check, {
    interval = 50,
    timeout = 5000
  } = {}) {
    return new Promise((resolve) => {
      const start = Date.now();

      const timer = setInterval(() => {

        if (check()) {
          clearInterval(timer);
          resolve(true);
          return;
        }

        if (Date.now() - start >= timeout) {
          clearInterval(timer);
          resolve(false);
        }

      }, interval);
    });
  }

  kebabToTitle(str = '') {
    return str
      .split('-')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }

  toast(text = null, {
    icon = null,
    duration = 1000,
    target = "body"
  } = {}) {
    let toast = document.getElementById("_toast");

    if (!toast) {
      toast = document.createElement("div");
      toast.id = "_toast";

      Object.assign(toast.style, {
        position: "fixed",
        top: "10px",
        left: "10px",
        zIndex: "2147483647",
        background: "rgba(39, 39, 39, 0.85)",
        color: "#fff",
        borderRadius: "8px",
        font: "14px sans-serif",
        opacity: "0",
        transition: "opacity .2s",
        pointerEvents: "none"
      });

      (document.querySelector(target) || document.body).appendChild(toast);
    }

    toast.setContent = (content) => {
      toast.innerHTML = `
        <div style="display: flex; justify-content: center; align-items: center;">
          ${content.icon || `<svg style="margin-right: 8px;" width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"> <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" /> </svg>`}
          <span>${content.text}</span>
        </div>
      `;
    };

    toast.show = (time = duration) => {
      toast.style.padding = "12px 16px";
      toast.style.opacity = "1";

      clearTimeout(toast._timer);
      if (time !== 0) {
        toast._timer = setTimeout(() => toast.hide(), time);
      }
    };

    toast.hide = () => {
      toast.style.opacity = "0";
    };

    if (text) {
      toast.setContent({ text: text, icon: icon });
    }

    return toast;
  }
  
}

window['h'] = new TrStreamHelper();
})();
  